export const DOWNLOAD_RISKFACTOR_TEMPLATE = 'src/component/RiskFactor/Search/Download_Riskfactor_Template';
export const DOWNLOAD_RISKFACTOR_TEMPLATE_SUCCESS = 'src/component/RiskFactor/Search/Download_Riskfactor_Template_Success';
export const DOWNLOAD_RISKFACTOR_TEMPLATE_FAILURE = 'src/component/RiskFactor/Search/Download_Riskfactor_Template_Failure';

export const downloadRiskfactorTemplate = (data) => {
    return {
        type: DOWNLOAD_RISKFACTOR_TEMPLATE,
        data
    }
}
export const downloadRiskfactorTemplateSuccess = (data) => {
    return {
        type: DOWNLOAD_RISKFACTOR_TEMPLATE_SUCCESS,
        data
    }
}
export const downloadRiskfactorTemplateFailure = (data) => {
    return {
        type: DOWNLOAD_RISKFACTOR_TEMPLATE_FAILURE,
        data
    }
}

export const UPLOAD_RISKFACTOR_TEMPLATE = 'src/component/RiskFactor/Search/Upload_Riskfactor_Template';
export const UPLOAD_RISKFACTOR_TEMPLATE_SUCCESS = 'src/component/RiskFactor/Search/Upload_Riskfactor_Template_Success';
export const UPLOAD_RISKFACTOR_TEMPLATE_FAILURE = 'src/component/RiskFactor/Search/Upload_Riskfactor_Template_Failure';

export const uploadRiskfactorTemplate = (data) => {
    return {
        type: UPLOAD_RISKFACTOR_TEMPLATE,
        data
    }
}
export const uploadRiskfactorTemplateSuccess = (data) => {
    return {
        type: UPLOAD_RISKFACTOR_TEMPLATE_SUCCESS,
        data
    }
}
export const uploadRiskfactorTemplateFailure = (data) => {
    return {
        type: UPLOAD_RISKFACTOR_TEMPLATE_FAILURE,
        data
    }
}